import React from 'react';
import { cn } from '@/shared/utils/cn';
import { SidebarSectionTitleProps } from '../../types';

/**
 * ============================================
 * SIDEBAR SECTION TITLE - ATOM
 * ============================================
 * Título de sección para el sidebar.
 * Usado para dividir grupos de menús.
 */
export const SidebarSectionTitle: React.FC<SidebarSectionTitleProps> = ({ title, className }) => {
  return (
    <span
      className={cn(
        'ui-text-body-xs-regular ui-font-body-xs-regular',
        'ui-uppercase ui-text-tertiary',
        className,
      )}
    >
      {title}
    </span>
  );
};
